// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/fancy-landing/private-secure-icon.svg';

export const PrivateSecure = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} sx={{ fill: 'none' }} />
);
